module.exports = __webpack_public_path__ + "img/4-3.b7a6d4c9.jpg";